module.exports = "https://cdn2-fs.clearscore.com/flux/images/5a0488d61e257fa8bd856ab701f9e6bc.jpg";